export const Fonts = { Light: 300, Medium: 500, SemiBold: 600, Bold: 700 };
